import _Tabs from './subcomponents/Tabs';
import _Tab from './subcomponents/Tab';

const Tabs = _Tabs;
Tabs.Tab = _Tab;

export default Tabs;
